import React from 'react';

const CalWeekSummary = ({ weekSummary, hasItems }) => {
    const statistics = Array.isArray(weekSummary?.statistics) ? weekSummary.statistics.slice(0, 3) : [];
    const isLoading = !!weekSummary?.isLoading;

    return (
        <div
            className="uiCalWeekSummary"
            style={{
                borderTop: '1px solid #e6ebf5',
                background: '#f7faff',
                padding: '8px 10px',
                color: '#708099',
                fontSize: '12px',
                minHeight: '62px',
                boxSizing: 'border-box',
                flex: '0 0 62px'
            }}
        >
            {statistics.length > 0 ? (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: '6px',
                        alignItems: 'stretch'
                    }}
                >
                    {statistics.map((statistic, index) => (
                        <div
                            key={`${statistic?.key || 'stat'}_${index}`}
                            title={statistic?.tooltip || ''}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'flex-start',
                                gap: '4px',
                                minWidth: '0',
                                flex: '1 1 0',
                                padding: '6px 8px',
                                border: '1px solid rgba(183, 198, 221, 0.7)',
                                borderRadius: '8px',
                                background: '#ffffff'
                            }}
                        >
                            <span
                                style={{
                                    color: '#6a788e',
                                    fontSize: '11px',
                                    lineHeight: '13px',
                                    minHeight: '13px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}
                            >
                                {statistic?.key || ''}
                            </span>
                            <span
                                style={{
                                    color: '#33455f',
                                    fontWeight: 700,
                                    fontSize: '18px',
                                    lineHeight: '20px',
                                    minHeight: '20px'
                                }}
                            >
                                {statistic?.valF || ''}
                            </span>
                        </div>
                    ))}
                </div>
            ) : hasItems ? (
                <div
                    style={{
                        color: '#8a97aa',
                        minHeight: '44px',
                        display: 'flex',
                        alignItems: 'center',
                        padding: '0 4px'
                    }}
                >
                    {isLoading ? 'Loading summary...' : 'Summary pending'}
                </div>
            ) : null}
        </div>
    );
};

export default CalWeekSummary;
